/**
 * @license
 * Copyright (c) 2018 Crius Authors. All rights reserved.
 */

import '@polymer/polymer/polymer-element.js';

const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = `
<dom-module id="cs-shared-styles-typography-headings">
	<template>
		<custom-style>
            <style>
                .d1,
                .d2,
                .d3,
                .d4 {
                    font-family: var(--cs-theme-typographic-headings-font-family);
                    text-transform: var(--cs-text-case);
                    transition: opacity var(--cs-interface-expansion)
                }

                :host([wf-loading]) .d1,
                :host([wf-loading]) .d2,
                :host([wf-loading]) .d3,
                :host([wf-loading]) .d4 {
                    opacity: 0
                }

                .d1-light,
                .d2-brand-light,
                .d2-light,
                .d3-brand-light,
                .d3-light,
                .d4-brand-light,
                .d4-light {
                    color: var(--cs-light-color)
                }

                .d1 {
                    font-size: var(--cs-theme-d1-font-size-mobile);
                    font-style: var(--cs-theme-d1-font-style);
                    font-weight: var(--cs-theme-d1-font-weight);
                    letter-spacing: var(--cs-theme-d1-letter-spacing-mobile);
                    line-height: var(--cs-theme-d1-line-height-mobile)
                }

                :host([text-color*=brand]) .d1 {
                    color: var(--cs-theme-color)
                }

                .h4:not([hidden])+.d1,
                .h4:not([hidden])+dom-if+.d1 {
                    margin-top: var(--cs-theme-d1-after-h4-margin-top-mobile)
                }

                .l2:not([hidden])+.d1 {
                    margin-top: var(--cs-theme-d1-after-l2-margin-top-mobile)
                }

                img+dom-if+.d1 {
                    margin-top: 23px
                }

                @media only screen and (min-width:768px) {
                    .d1 {
                        font-size: var(--cs-theme-d1-font-size-tablet-portrait);
                        letter-spacing: var(--cs-theme-d1-letter-spacing-tablet-portrait);
                        line-height: var(--cs-theme-d1-line-height-tablet-portrait)
                    }

                    .h4:not([hidden])+.d1,
                    .h4:not([hidden])+dom-if+.d1 {
                        margin-top: var(--cs-theme-d1-after-h4-margin-top-tablet-portrait)
                    }

                    .l2:not([hidden])+.d1 {
                        margin-top: var(--cs-theme-d1-after-l2-margin-top-tablet-portrait)
                    }
                }

                @media only screen and (min-width:1024px) {
                    .d1 {
                        font-size: var(--cs-theme-d1-font-size-tablet-landscape);
                        letter-spacing: var(--cs-theme-d1-letter-spacing-tablet-landscape);
                        line-height: var(--cs-theme-d1-line-height-tablet-landscape)
                    }

                    .l2:not([hidden])+.d1 {
                        margin-top: var(--cs-theme-d1-after-l2-margin-top-tablet-landscape)
                    }

                    img+dom-if+.d1 {
                        margin-top: 30px
                    }
                }

                @media only screen and (min-width:1456px) {
                    .d1 {
                        font-size: var(--cs-theme-d1-font-size-desktop);
                        letter-spacing: var(--cs-theme-d1-letter-spacing-desktop);
                        line-height: var(--cs-theme-d1-line-height-desktop)
                    }

                    .h4:not([hidden])+.d1,
                    .h4:not([hidden])+dom-if+.d1 {
                        margin-top: var(--cs-theme-d1-after-h4-margin-top-desktop)
                    }

                    .l2:not([hidden])+.d1 {
                        margin-top: var(--cs-theme-d1-after-l2-margin-top-desktop)
                    }

                    img+dom-if+.d1 {
                        margin-top: 53px
                    }
                }

                .d2 {
                    font-size: var(--cs-theme-d2-font-size-mobile);
                    font-style: var(--cs-theme-d2-font-style);
                    font-weight: var(--cs-theme-d2-font-weight);
                    letter-spacing: var(--cs-theme-d2-letter-spacing-mobile);
                    line-height: var(--cs-theme-d2-line-height-mobile)
                }

                .h4:not([hidden])+.d2,
                .h4:not([hidden])+dom-if+.d2 {
                    margin-top: var(--cs-theme-d2-after-h4-margin-top-mobile)
                }

                .l2:not([hidden])+.d2 {
                    margin-top: var(--cs-theme-d2-after-l2-margin-top-mobile)
                }

                img+dom-if+.d2 {
                    margin-top: 23px
                }

                @media only screen and (min-width:768px) {
                    .d2 {
                        font-size: var(--cs-theme-d2-font-size-tablet-portrait);
                        letter-spacing: var(--cs-theme-d2-letter-spacing-tablet-portrait);
                        line-height: var(--cs-theme-d2-line-height-tablet-portrait)
                    }
                }

                @media only screen and (min-width:1024px) {
                    .d2 {
                        font-size: var(--cs-theme-d2-font-size-tablet-landscape);
                        letter-spacing: var(--cs-theme-d2-letter-spacing-tablet-landscape);
                        line-height: var(--cs-theme-d2-line-height-tablet-landscape)
                    }

                    .h4:not([hidden])+.d2,
                    .h4:not([hidden])+dom-if+.d2 {
                        margin-top: var(--cs-theme-d2-after-h4-margin-top-tablet-landscape)
                    }

                    .l2:not([hidden])+.d2 {
                        margin-top: var(--cs-theme-d2-after-l2-margin-top-tablet-landscape)
                    }

                    img+dom-if+.d2 {
                        margin-top: 30px
                    }
                }

                @media only screen and (min-width:1456px) {
                    .d2 {
                        font-size: var(--cs-theme-d2-font-size-desktop);
                        letter-spacing: var(--cs-theme-d2-letter-spacing-desktop);
                        line-height: var(--cs-theme-d2-line-height-desktop)
                    }

                    .h4:not([hidden])+.d2,
                    .h4:not([hidden])+dom-if+.d2 {
                        margin-top: var(--cs-theme-d2-after-h4-margin-top-desktop)
                    }

                    .l2:not([hidden])+.d2 {
                        margin-top: var(--cs-theme-d2-after-l2-margin-top-desktop)
                    }

                    img+dom-if+.d2 {
                        margin-top: 53px
                    }
                }

                .d3 {
                    font-size: var(--cs-theme-d3-font-size-mobile);
                    font-style: var(--cs-theme-d3-font-style);
                    font-weight: var(--cs-theme-d3-font-weight);
                    letter-spacing: var(--cs-theme-d3-letter-spacing-mobile);
                    line-height: var(--cs-theme-d3-line-height-mobile)
                }

                .h4:not([hidden])+.d3,
                .h4:not([hidden])+dom-if+.d3 {
                    margin-top: var(--cs-theme-d3-after-h4-margin-top-mobile)
                }

                .h6:not([hidden])+.d3,
                .h6:not([hidden])+dom-if+.d3 {
                    margin-top: var(--cs-theme-d3-after-h6-margin-top-mobile)
                }

                .l2:not([hidden])+.d3 {
                    margin-top: var(--cs-theme-d3-after-l2-margin-top-mobile)
                }

                img+dom-if+.d3 {
                    margin-top: 23px
                }

                @media only screen and (min-width:768px) {
                    .d3 {
                        font-size: var(--cs-theme-d3-font-size-tablet-portrait);
                        letter-spacing: var(--cs-theme-d3-letter-spacing-tablet-portrait);
                        line-height: var(--cs-theme-d3-line-height-tablet-portrait)
                    }
                }

                @media only screen and (min-width:1024px) {
                    .d3 {
                        font-size: var(--cs-theme-d3-font-size-tablet-landscape);
                        letter-spacing: var(--cs-theme-d3-letter-spacing-tablet-landscape);
                        line-height: var(--cs-theme-d3-line-height-tablet-landscape)
                    }

                    .h4:not([hidden])+.d3,
                    .h4:not([hidden])+dom-if+.d3 {
                        margin-top: var(--cs-theme-d3-after-h4-margin-top-tablet-landscape)
                    }

                    .h6:not([hidden])+.d3,
                    .h6:not([hidden])+dom-if+.d3 {
                        margin-top: var(--cs-theme-d3-after-h6-margin-top-tablet-landscape)
                    }

                    .l2:not([hidden])+.d3 {
                        margin-top: var(--cs-theme-d3-after-l2-margin-top-tablet-landscape)
                    }

                    img+dom-if+.d3 {
                        margin-top: 30px
                    }
                }

                @media only screen and (min-width:1456px) {
                    .d3 {
                        font-size: var(--cs-theme-d3-font-size-desktop);
                        letter-spacing: var(--cs-theme-d3-letter-spacing-desktop);
                        line-height: var(--cs-theme-d3-line-height-desktop)
                    }

                    .h4:not([hidden])+.d3,
                    .h4:not([hidden])+dom-if+.d3 {
                        margin-top: var(--cs-theme-d3-after-h4-margin-top-desktop)
                    }

                    .h6:not([hidden])+.d3,
                    .h6:not([hidden])+dom-if+.d3 {
                        margin-top: var(--cs-theme-d3-after-h6-margin-top-desktop)
                    }

                    .l2:not([hidden])+.d3 {
                        margin-top: var(--cs-theme-d3-after-l2-margin-top-desktop)
                    }

                    img+dom-if+.d3 {
                        margin-top: 53px
                    }
                }

                .d4 {
                    font-size: var(--cs-theme-d4-font-size-mobile);
                    font-style: var(--cs-theme-d4-font-style);
                    font-weight: var(--cs-theme-d4-font-weight);
                    letter-spacing: var(--cs-theme-d4-letter-spacing-mobile);
                    line-height: var(--cs-theme-d4-line-height-mobile)
                }

                .h4:not([hidden])+.d4,
                .h4:not([hidden])+dom-if+.d4 {
                    margin-top: var(--cs-theme-d4-after-h4-margin-top-mobile)
                }

                .l2:not([hidden])+.d4 {
                    margin-top: var(--cs-theme-d4-after-l2-margin-top-mobile)
                }

                img+dom-if+.d4 {
                    margin-top: 23px
                }

                @media only screen and (min-width:1024px) {
                    .d4 {
                        font-size: var(--cs-theme-d4-font-size-tablet-landscape);
                        letter-spacing: var(--cs-theme-d4-letter-spacing-tablet-landscape);
                        line-height: var(--cs-theme-d4-line-height-tablet-landscape)
                    }

                    .h4:not([hidden])+.d4,
                    .h4:not([hidden])+dom-if+.d4 {
                        margin-top: var(--cs-theme-d4-after-h4-margin-top-tablet-portrait)
                    }

                    .l2:not([hidden])+.d4 {
                        margin-top: var(--cs-theme-d4-after-l2-margin-top-tablet-landscape)
                    }

                    img+dom-if+.d4 {
                        margin-top: 30px
                    }
                }

                @media only screen and (min-width:1456px) {
                    .d4 {
                        font-size: var(--cs-theme-d4-font-size-desktop);
                        letter-spacing: var(--cs-theme-d4-letter-spacing-desktop);
                        line-height: var(--cs-theme-d4-line-height-desktop)
                    }

                    .h4:not([hidden])+.d4,
                    .h4:not([hidden])+dom-if+.d4 {
                        margin-top: var(--cs-theme-d4-after-h4-margin-top-desktop)
                    }

                    .l2:not([hidden])+.d4 {
                        margin-top: var(--cs-theme-d4-after-l2-margin-top-desktop)
                    }

                    img+dom-if+.d4 {
                        margin-top: 53px
                    }
                }
            </style>
		<custom-style>
	</template>
</dom-module>`;

document.head.appendChild($_documentContainer.content);
